// @flow

/* Libs */
import { Link, NavLink } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

/* Store */
import useApplicationStore from 'Stores/Application';

import { useOutside } from 'Helpers/hooks';

/* Components */
import Icon from 'Components/Icon';

/* Styles */
import './Sidebar.scss';

const Sidebar = () => {
	const isMobile = useMediaQuery({ query: `(max-width: ${Constants.RESPONSIVE_SM}px)` });
	const showSidebar = useApplicationStore(store => store.showSidebar);
	const setShowSidebar = useApplicationStore(store => store.setShowSidebar);
	const sidebarRef = useOutside(showSidebar, () => {
		setShowSidebar(false);
	});

	return (
		<div className={`App-sidebar ${isMobile ? 'mobile' : ''} ${showSidebar ? 'show' : ''}`}>
			<div className="sidebar" ref={sidebarRef}>
				<div className="App-sidebar-links">
					<Link to="/" onClick={() => setShowSidebar(false)}>
						<h2>BS</h2>
					</Link>
					<NavLink to="/" exact onClick={() => setShowSidebar(false)}>
						<Icon name="home" />
						<p>Dashboard</p>
					</NavLink>
					<NavLink to="/inventory" onClick={() => setShowSidebar(false)}>
						<Icon name="stock" />
						<p>Inventaire</p>
					</NavLink>
					<NavLink to="/orders" onClick={() => setShowSidebar(false)}>
						<Icon name="order" />
						<p>Commandes</p>
					</NavLink>
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
